// Panel "Herramientas": las acciones de IA del editor. Hoy una sola, "Dividir en
// capas" (1 crédito). Es presentacional — la llamada, el saldo y qué hacer con el
// resultado los maneja EditorShell.
//
// Mientras corre, el FONDO del botón se llena de izquierda a derecha con la misma
// keyframe (`expansion-progreso`, 40s) que la espera de la expansión mágica: es la
// única señal de avance honesta que tenemos (el job no reporta progreso real), y un
// spinner solo no cuenta que esto tarda medio minuto.

import { Layers, Loader2 } from 'lucide-react';
import CreditBadge from '../../../components/CreditBadge';
import { CREDITOS_DIVISION } from '../lib/dividirEnCapas';
import { PanelSheet } from './PanelSheet';

interface Props {
  onDividir: () => void;
  dividiendo: boolean;
  /** Sin una capa de imagen seleccionada no hay nada que dividir. */
  hayImagen: boolean;
  onClose: () => void;
}

export function HerramientasPanel({ onDividir, dividiendo, hayImagen, onClose }: Props) {
  const bloqueado = !hayImagen && !dividiendo;
  return (
    <PanelSheet title="Herramientas" onClose={onClose}>
      <div className="p-3">
        <button
          type="button"
          onClick={onDividir}
          disabled={bloqueado || dividiendo}
          aria-busy={dividiendo}
          className={`relative w-full overflow-hidden text-left rounded-md border transition-colors ${
            bloqueado
              ? 'border-neutral-200 opacity-50 cursor-not-allowed'
              : 'border-neutral-200 hover:border-brand-primary/40 hover:bg-neutral-50 active:scale-[0.99]'
          }`}
        >
          {/* Relleno de progreso. Va DEBAJO del contenido (z-0 vs z-10) y no toca el
              layout: crece con scaleX, así que no repinta el texto en cada frame. */}
          {dividiendo && (
            <div
              aria-hidden
              className="absolute inset-y-0 left-0 w-full z-0"
              style={{
                transformOrigin: 'left',
                animation: 'expansion-progreso 40s cubic-bezier(0, 0, 0.2, 1) forwards',
                background: 'rgba(22, 68, 235, 0.12)',
              }}
            />
          )}
          <div className="relative z-10 flex items-start gap-3 p-3">
            <div className="w-9 h-9 shrink-0 rounded-sm bg-neutral-100 flex items-center justify-center">
              {dividiendo ? (
                <Loader2 className="w-4 h-4 animate-spin text-brand-primary" />
              ) : (
                <Layers className="w-4 h-4 text-neutral-600" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <p className="text-[14px] font-medium text-brand-black">
                  {dividiendo ? 'Dividiendo…' : 'Dividir en capas'}
                </p>
                <CreditBadge credits={CREDITOS_DIVISION} size="sm" />
              </div>
              <p className="text-[12.5px] text-neutral-500 mt-0.5 leading-snug">
                {dividiendo
                  ? 'Separando el fondo de los elementos. Puede tardar un minuto.'
                  : hayImagen
                    ? 'Separá el fondo y los elementos para moverlos por separado'
                    : 'Elegí una imagen del lienzo para dividirla'}
              </p>
            </div>
          </div>
        </button>
      </div>
    </PanelSheet>
  );
}
